import React, { useState } from 'react';
import { Grid, Typography, useTheme } from '@mui/material';
import UseCurrency from '@shared/hooks/UseCurrency';
import CardAir from './CardAir';

import { getBestPriceByAirlinesStyles } from './styles';

const BestPriceByAirlines = ({
  data,
  handleScroll,
  selectedId,
  isCustomSearch,
}) => {
  const theme = useTheme();
  const styles = getBestPriceByAirlinesStyles(theme, isCustomSearch);

  const [showMoreOptions, setShowMoreOptions] = useState(false);

  const { currency } = UseCurrency();

  return (
    <Grid container sx={styles.containerSx}>
      <Grid container spacing={0} sx={styles.cardsContainerSx}>
        {data.map(
          (element, i) =>
            i <= 2 && (
              <React.Fragment key={+i}>
                <CardAir
                  i={i}
                  element={element}
                  sxCard={styles.bestPriceAirCardSx}
                  handleScroll={handleScroll}
                  selectedId={selectedId}
                  currency={currency}
                  bestPrice={data}
                  isCustomSearch={isCustomSearch}
                />
                {data.length >= 4 && i === 2 && (
                  <Grid
                    sm={2}
                    item
                    sx={{
                      ...styles.bestPriceAirCardSx,
                      minHeight: '104px',
                      justifyContent: 'center',
                    }}
                    onClick={() => setShowMoreOptions(!showMoreOptions)}
                  >
                    <Typography sx={styles.moreOptionsSx}>
                      {showMoreOptions ? 'Ocultar' : 'Más opciones'}
                    </Typography>
                  </Grid>
                )}
              </React.Fragment>
            )
        )}
      </Grid>

      {showMoreOptions && (
        <Grid container spacing={2} sx={styles.cardsContainerSx}>
          {data.map(
            (element, i) =>
              i >= 3 && (
                <CardAir
                  i={i}
                  key={'more+option' + i}
                  element={element}
                  sxCard={styles.bestPriceAirCardSx}
                  handleScroll={handleScroll}
                  selectedId={selectedId}
                  currency={currency}
                  bestPrice={data}
                  isCustomSearch={isCustomSearch}
                />
              )
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default BestPriceByAirlines;
